    /**
    * Created with JetBrains WebStorm.
    * User: sebastienbeaujard
    * Date: 16/01/2018
    * Time: 18h01
    * To change this template use File | Settings | File Templates.
    */

    angular.module('FlexyBeautyApp.services').
    factory('CurrencyView',["$filter","CurrencyData", "CurrencySrv",
    function ($filter,CurrencyData,CurrencySrv)
    {

        var  CurrencyView = function(currency,cIndex)
        {
            this.cIndex = cIndex;
            this.isDeleted = false;
            this.id = null;
            this.name = null;
            this.code = false;
            this.symbol = null;
            this.codeMango = null;
            this.symbol = null;
            this.typeBankAccount = null;

            this.loadDataFrom(currency);
        };
        CurrencyView.prototype.getModel = function()
        {
            if (this.cIndex!=-1)
                return CurrencyData.getByIndex(this.cIndex);
            return null;
        }
        CurrencyView.prototype.loadDataFrom = function(currency)
        {
            if (currency !==undefined && currency)
            {
                this.id = currency.id;
                this.name = currency.name;
                this.code = currency.code;
                this.symbol = currency.symbol;
                this.codeMango = currency.codeMango;
                this.typeBankAccount = currency.typeBankAccount;
            }
        }
        CurrencyView.prototype.copyDataTo = function(currency)//
        {
            currency.name = this.name;
            currency.code = this.code;
            currency.symbol = this.symbol;
            currency.codeMango = this.codeMango;
            currency.typeBankAccount = this.typeBankAccount;

        }

        CurrencyView.prototype.removeModel = function()
        {
            var currency = this.getModel();
            if (currency!=null)
                CurrencySrv.remove(currency);
        }
        CurrencyView.prototype.reloadModel = function()
        {
            var currency = this.getModel();
            if (currency!=null)
                this.loadDataFrom(currency);

        }
        CurrencyView.prototype.updateModel = function(save,endFunction)
        {
            //Save by default
            var currency = this.getModel();
            if (!currency)//create it
            {
                currency = new Currency();
                this.cIndex = CurrencyData.getIndexOf(currency);
            }

            this.copyDataTo(currency);
            if (save===undefined||save)//Save by default
                CurrencySrv.save(currency,endFunction);
        }
        CurrencyView.prototype.restoreModel = function()
        {
            var currency = this.getModel();
            if (currency)
                CurrencySrv.restore(currency);
        }
        CurrencyView.prototype.canSave = function()
        {
            return true;
        }


        return  CurrencyView;
    }]);



// WEBPACK FOOTER //
// ./js/services/views/CurrencyView.js